import noneRuntime_3607cM0koNmp45_aTks7IE0ta60_ELGo59w47Y16nbg8Y from '/home/snaumann/Development/public_html/awo-lausitz/public/node_modules/.pnpm/@nuxt+image@2.1.0_@types+node@24.13.3_magic-string@1.1.0_magicast@0.5.4_rolldown@1.2.3__c2d5f1e2c0cb194c135ba2e7148c399a/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime_36MYqODb_BRZDJfGwmZdShvBQ5bmvbB_45Xlw_45uKYkhuKuA from '/home/snaumann/Development/public_html/awo-lausitz/cms/vendors/gsmaterials/imgProvider.ts'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"gs"} */
  provider: "gs",
  providers: {
      ['none']: { setup: noneRuntime_3607cM0koNmp45_aTks7IE0ta60_ELGo59w47Y16nbg8Y, defaults: true },
  ['gs']: { setup: gsRuntime_36MYqODb_BRZDJfGwmZdShvBQ5bmvbB_45Xlw_45uKYkhuKuA, defaults: undefined }
  }
}
